import { render, staticRenderFns } from "./muestra-construccion.html?vue&type=template&id=6f9e14d4&scoped=true&"
import script from "./muestra-construccion.ts?vue&type=script&lang=ts&"
export * from "./muestra-construccion.ts?vue&type=script&lang=ts&"
import style0 from "./muestra-construccion.scss?vue&type=style&index=0&id=6f9e14d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9e14d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
